module.exports = __webpack_public_path__ + "img/add.80ec5c46.png";